"use client";

import type { ReactNode } from "react";
import { useFormContext } from "react-hook-form";
import type { TicketType } from "../types";

interface Props {
	type: TicketType;
	children: ReactNode;
	inverse?: boolean;
}

export function ShowTicketType({ type, children, inverse }: Props) {
	const { watch } = useFormContext();
	const category: unknown = watch("type");

	if (inverse) {
		if (category === type) {
			return null;
		}

		return children;
	}

	if (category !== type) {
		return null;
	}

	return children;
}
